import { useEffect, useState } from "react";

type Props = {
  postUrl: string;
};

declare global {
  interface Window {
    FB: any;
  }
}

const FacebookPostEmbed = ({ postUrl }: Props) => {
  const [width, setWidth] = useState(
    window.innerWidth > 600 ? 500 : window.innerWidth - 40
  );

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth > 600 ? 500 : window.innerWidth - 40);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement("script");
      script.src =
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v22.0";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.onload = () => {
        window.FB?.XFBML.parse();
      };
      document.body.appendChild(script);
    } else {
      window.FB.XFBML.parse();
    }
  }, [postUrl]);

  return (
    <div
      className="h-full duration-300 transform hover:transition-transform hover:scale-105 fb-post-wrapper"
      style={{ display: "flex" }}
    >
      <div className={`fb-post`} data-href={postUrl} data-width={width}></div>
    </div>
  );
};

export default FacebookPostEmbed;
